import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
import { computed, nextTick, ref } from "vue";
import Strings from "src/shared/Strings";
import MultiSelectDropDownInput from "src/shared/v-components/ui/form/MultiSelectDropDownInput.vue";
import AllowedValuesDraggableList from "./AllowedValuesDraggableList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EnumListComponentVariableRawValue',
    props: {
        modelValue: {},
        allowedValues: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const wrapper = ref(null);
        const emit = __emit;
        const isEnumList = (value) => {
            return (Array.isArray(value) && value.every((item) => typeof item === "string"));
        };
        const valueProxy = computed({
            get() {
                return isEnumList(props.modelValue) ? props.modelValue : [];
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        const remove = (tag) => {
            nextTick(() => {
                const cloned = [...valueProxy.value];
                valueProxy.value = cloned.filter((value) => value !== tag);
            });
        };
        const options = computed(() => {
            return props.allowedValues.map((value) => {
                return {
                    displayName: Strings.capitalize(value),
                    value: value,
                };
            });
        });
        const wrapperWidth = computed(() => {
            var _a, _b;
            return (_b = (_a = wrapper.value) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "manageable-list-wrapper",
                ref_key: "wrapper",
                ref: wrapper
            }, [
                _createVNode(MultiSelectDropDownInput, {
                    value: valueProxy.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event)),
                    options: options.value,
                    prompt: "Add a Value"
                }, null, 8 /* PROPS */, ["value", "options"]),
                (valueProxy.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(AllowedValuesDraggableList, {
                            list: valueProxy.value,
                            "onUpdate:list": _cache[1] || (_cache[1] = ($event) => ((valueProxy).value = $event)),
                            "is-column-flow": wrapperWidth.value < 350,
                            onRemove: remove
                        }, null, 8 /* PROPS */, ["list", "is-column-flow"])
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */));
        };
    }
});
